function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 922 892",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Artboard1",
    transform: "matrix(1,0,0,1,-537.402,-425.197)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 537.402,
    y: 425.197,
    width: 921.26,
    height: 891.732,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0.401575,0.19685)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 996.555,
    cy: 860.728,
    r: 429.626,
    style: {
      fill: "rgb(254,218,44)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.800687,0,0,0.800687,201.075,168.798)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 996.555,
    cy: 860.728,
    r: 429.626,
    style: {
      fill: "rgb(252,170,23)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.04545,0,0,1.06024,-239.893,-1056.58)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1192.91,1564.96L1251.25,1734.31L1440.04,1734.31L1287.31,1838.97L1345.64,2008.31L1192.91,1903.65L1040.18,2008.31L1098.52,1838.97L945.788,1734.31L1134.58,1734.31L1192.91,1564.96Z",
    style: {
      fill: "rgb(254,218,44)"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.d8614b56fb594260425333b2f4c683d3.svg";
export { ForwardRef as ReactComponent };